import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { AiDraftListItem } from "@/actions/serverActions/scheduling/createAiDraftAction";

interface SchedulingDraftsState {
  items: AiDraftListItem[];
}

const initialState: SchedulingDraftsState = {
  items: [],
};

const schedulingDraftsSlice = createSlice({
  name: "schedulingDrafts",
  initialState,
  reducers: {
    setSchedulingDrafts(state, action: PayloadAction<AiDraftListItem[]>) {
      state.items = action.payload;
    },
    addSchedulingDraft(state, action: PayloadAction<AiDraftListItem>) {
      state.items.unshift(action.payload);
    },
    removeSchedulingDraft(state, action: PayloadAction<string>) {
      state.items = state.items.filter((d) => d.id !== action.payload);
    },
  },
});

export const {
  setSchedulingDrafts,
  addSchedulingDraft,
  removeSchedulingDraft,
} = schedulingDraftsSlice.actions;
export default schedulingDraftsSlice.reducer;
